import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { ClientPaymentMethodDto } from "./client-payment-method.dto";
import { CreateClientPaymentMethodDto } from "./create-client-payment-method.dto";
import { UpdateClientPaymentMethodDto } from "./update-client-payment-method.dto";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class ClientPaymentMethodsResource extends ResourceBaseService<
  ClientPaymentMethodDto,
  CreateClientPaymentMethodDto,
  UpdateClientPaymentMethodDto
> {
  protected EntityDto = ClientPaymentMethodDto;
  protected CreateEntityDto = CreateClientPaymentMethodDto;
  protected UpdateEntityDto = UpdateClientPaymentMethodDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/client-payment-methods");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }
}
